import React from "react";
import { useNavigate } from "react-router-dom";
import { Footer } from "../footer/footer";
import { imagepaths } from "../../utils/image";

export const Skills = () => {
  const navigate = useNavigate();
  const goToHome = () => {
    navigate("/");
  };

  const goToAbout = () => {
    navigate("/about");
  };

  const skillsData = [
    {
      category: "Programming Languages",
      technologies: [
        { name: "Python", image: "Python" },
        { name: "C", image: "C" },
        { name: "Java", image: "Java" },
        { name: "JavaScript", image: "Javascript" },
        { name: "TypeScript", image: "Typescript" },
        { name: "PySpark", image: "PySpark" },
      ],
    },
    {
      category: "Frontend Technologies",
      technologies: [
        { name: "React.js", image: "React" },
        { name: "Angular", image: "Angular" },
        { name: "Ionic", image: "Ionic" },
        { name: "Tailwind CSS", image: "Tailwind" },
        { name: "CSS", image: "Css" },
        { name: "HTML", image: "Html" },
      ],
    },
    {
      category: "Backend Technologies",
      technologies: [
        { name: "Node.js", image: "Nodejs" },
        { name: "Express.js", image: "Express" },
        { name: "NestJS", image: "Nestjs" },
        { name: "Flask", image: "Flask" },
      ],
    },
    {
      category: "Mobile",
      technologies: [{ name: "Kotlin", image: "Kotlin" }],
    },
    {
      category: "Databases",
      technologies: [
        { name: "MySQL", image: "Mysql" },
        { name: "PostgreSQL", image: "PostgreSQL" },
        { name: "MongoDB", image: "Mongodb" },
        { name: "Firebase (Firestore, FCM)", image: "Firebase" },
        { name: "ChromaDB", image: "ChromaDB" },
      ],
    },
    {
      category: "Cloud Platforms",
      technologies: [
        { name: "AWS", image: "AWS" },
        { name: "GCP", image: "GCP" },
      ],
    },
    {
      category: "AI/ML Tools & Libraries",
      technologies: [
        { name: "Hugging Face", image: "HuggingFace" },
        { name: "LLaVA", image: "LLaVA" },
        { name: "Ollama", image: "Ollama" },
      ],
    },
    {
      category: "Developer Tools & DevOps",
      technologies: [
        { name: "Git", image: "Git" },
        { name: "Docker", image: "Docker" },
        { name: "JMeter", image: "JMeter" },
        { name: "JUnit", image: "JUnit" },
      ],
    },
    {
      category: "Productivity & Visualization Tools",
      technologies: [
        { name: "Microsoft Word", image: "Word" },
        { name: "PowerPoint", image: "PowerPoint" },
        { name: "Excel", image: "Excel" },
      ],
    },
  ];

  return (
    <div className="flex flex-col w-full h-full px-4 py-10 font-rubik overflow-scroll no-scrollbar max-w-7xl mx-auto md:px-16 lg:px-32">
      {/* Header */}
      <div className="flex flex-col w-full mb-10">
        <div className="flex justify-between items-center">
          <div
            className="text-blue text-lg sm:text-xl md:text-2xl font-medium cursor-pointer"
            onClick={goToHome}
          >
            Vishal
          </div>
          <div
            className="bg-gradient-to-tr from-peach to-peachLite text-transparent bg-clip-text text-base sm:text-lg md:text-xl font-medium cursor-pointer"
            onClick={goToAbout}
          >
            About
          </div>
        </div>
      </div>

      {/* Title */}
      <div className="w-full bg-gradient-to-tr from-peach to-peachLite bg-clip-text text-transparent text-4xl font-medium">
        Skills
      </div>

      {/* Skills Grid */}
      <div className="flex flex-col font-normal text-blue text-base leading-loose sm:text-lg md:text-xl max-w-3xl sm:max-w-4xl md:max-w-5xl md:leading-loose mt-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-8">
          {skillsData.map((skillCategory, categoryIndex) => (
            <div
              key={categoryIndex}
              className="group relative overflow-hidden bg-white/10 backdrop-blur-md border border-white/20 rounded-3xl p-6 md:p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
            >
              {/* Card Content */}
              <div className="relative z-10">
                {/* Category Header */}
                <div className="mb-4 border-b border-peachLite pb-2">
                  <h3 className="text-blue text-md md:text-xl font-semibold mb-2">
                    {skillCategory.category}
                  </h3>
                  <p className="text-sm text-blue/70">
                    {skillCategory.description}
                  </p>
                </div>

                {/* Tech Pills */}
                <div className="flex flex-wrap gap-3 mt-4">
                  {skillCategory.technologies.map((tech, techIndex) => (
                    <div
                      key={techIndex}
                      className="flex items-center gap-2 px-3 py-1.5 rounded-full border border-Liteblue bg-white/20 backdrop-blur-sm transition-all duration-200 hover:scale-105 hover:bg-white/30"
                    >
                      <img
                        src={imagepaths(tech.image)}
                        alt={tech.image}
                        className="w-4 h-4 object-contain"
                      />
                      <span className="text-blue text-sm font-medium">
                        {tech.name}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Footer (with top margin to match section spacing) */}
      <div className="mt-10 flex flex-row items-center justify-center text-base sm:text-lg text-blue gap-4 w-full">
        <Footer />
      </div>
    </div>
  );
};
